import { HStack, Icon, IconButton } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { LuEllipsis } from 'react-icons/lu';
import { Button } from '@/components/ui/button';
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from '@/components/ui/menu';
import type { PageAction } from '@/contexts/PageChromeContext';

export function PageActionButton({ action }: { action: PageAction }) {
    return (
        <Button
            variant="outline"
            size="sm"
            onClick={action.onClick}
            disabled={action.disabled}
            loading={action.loading}
        >
            {action.icon && <Icon as={action.icon} />}
            {action.label}
        </Button>
    );
}

/** The ⋯ rollup. Sits left of the primary so the primary stays rightmost. */
export function PageActionMenu({ actions }: { actions: PageAction[] }) {
    const intl = useIntl();

    if (actions.length === 0) return null;

    return (
        <MenuRoot>
            <MenuTrigger asChild>
                <IconButton
                    variant="outline"
                    size="sm"
                    aria-label={intl.formatMessage({
                        id: 'c3a71f60-8d24-4b95-a0e7-52f9b61c8d43',
                        defaultMessage: 'More actions',
                    })}
                >
                    <LuEllipsis />
                </IconButton>
            </MenuTrigger>
            <MenuContent minW="200px">
                {actions.map((action) => (
                    <MenuItem
                        key={action.id}
                        value={action.id}
                        disabled={action.disabled || action.loading}
                        onClick={action.onClick}
                    >
                        <HStack gap={2}>
                            {action.icon && <Icon as={action.icon} />}
                            {action.label}
                        </HStack>
                    </MenuItem>
                ))}
            </MenuContent>
        </MenuRoot>
    );
}
